import React from 'react';
import { MedalContainer } from '@/components/custom/medal';
import { cn } from '@/lib/utils';

// Card de Nível/progresso lúdico (Versão B). Fonte única usada tanto na Home
// quanto na tela de Conquistas, para manter os dois cards idênticos.
// Deriva os valores do payload de /user_milestones.
export function LevelProgressCard({ milestones, className }) {
  const level = milestones?.['milestone-level']?.['level-order'] ?? 1;
  const nextLevel = milestones?.['next-milestone-level']?.['level-order'] ?? 2;
  const score = milestones?.score ?? 0;
  const required = milestones?.['next-milestone-level']?.['points-required'] ?? 500;
  // O denominador é o points-required do PRÓXIMO nível; não condicionar ao do
  // nível atual — no nível 1 ele é 0 (falsy) e zerava a barra.
  const percent = required ? (score / required) * 100 : 0;

  return (
    <div
      className={cn('relative flex items-center gap-4 rounded-[24px] p-5 pr-7 shadow-card', className)}
      style={{ background: 'var(--color-bg-amber-soft)' }}
    >
      <MedalContainer
        value={level}
        src="gold"
        size="gold"
        className="shrink-0"
      />
      <div className="min-w-0 flex-1">
        <div className="mb-1 flex items-baseline gap-1.5">
          <span
            className="text-lg font-extrabold leading-none"
            style={{ color: 'var(--color-secondary)' }}
          >
            Nível {level}
          </span>
          <span className="text-xs font-semibold text-neutral-500">rumo ao {nextLevel}</span>
        </div>
        {/* Selo do próximo nível ancorado ABSOLUTO à direita, centrado na barra:
            não infla a altura da linha, então os textos ficam colados na barra.
            pr-[54px] reserva o espaço do selo (44px) + gap. */}
        <div className="relative pr-[54px]">
          <div
            className="h-3 w-full overflow-hidden rounded-full"
            style={{ background: 'var(--color-secondary-lightest-alt)' }}
          >
            <div
              className="h-full rounded-full"
              style={{ width: `${Math.min(percent || 0, 100)}%`, background: 'var(--gradient-progress-bar)' }}
            />
          </div>
          <div className="absolute right-0 top-1/2 -translate-y-1/2">
            <MedalContainer
              value={nextLevel}
              src="primary"
              size="challenge"
              className="opacity-50"
            />
          </div>
        </div>
        <p
          className="mb-0 mt-1 pr-[54px] text-right text-xs font-bold"
          style={{ color: 'var(--color-secondary)' }}
        >
          {score}/{required} pontos
        </p>
      </div>
    </div>
  );
}
